module.exports = __webpack_public_path__ + "static/media/taurx-pharmaceuticals-ltd.f9ee90ff.png";